"use client";

import React from "react";
import { FaExchangeAlt } from "react-icons/fa";
import { FiArrowRight } from "react-icons/fi";
import styles from "./CardList.module.css";
import { useTransactions } from "./useTransactions";
import TransactionCard from "./TransactionCard";
import TransactionCardSkeleton from "./TransactionCardSkeleton";

const LatestTransactions: React.FC = () => {
  const { transactions, isFirstLoad, newItemId } = useTransactions();

  return (
    <div className={styles.containerNoBg}>
      <div className={styles.header}>
        <h3 className={styles.title}><FaExchangeAlt size={16} /> Latest transactions</h3>
        <a href="/txs" className={styles.viewAll}>
          View all transactions <FiArrowRight size={14} />
        </a>
      </div>
      <div
        className={`${styles.cardListVertical} ${isFirstLoad ? "" : styles.fadeIn}`}
      >
        {transactions.length > 0
          ? transactions.map((tx) => (
              <TransactionCard
                key={tx.hash}
                tx={tx}
                isNew={tx.hash === newItemId}
              />
            ))
          : Array.from({ length: 4 }).map((_, i) => (
              <TransactionCardSkeleton key={i} />
            ))}
      </div>
    </div>
  );
};

export default LatestTransactions;
